export default __webpack_public_path__ + "static/media/fk_logo.00618216.svg";